module.exports = __webpack_public_path__ + "static/media/arrow-white-left.b457ad0d.svg";